import { api, ApiError } from './api';

export interface Me {
  id: string; email: string;
  displayName: string; avatarEmoji: string;
  timezone: string; dayStartHour: number;
  totalXp: number; bankedEnergy: number;
  level: number;
  currentLevelXp: number; xpIntoLevel: number; xpForNextLevel: number;
}

export async function fetchMe(): Promise<Me | null> {
  try { return await api<Me>('/api/me'); }
  catch (e) {
    if (e instanceof ApiError && e.status === 401) return null;
    throw e;
  }
}

export async function login(email: string, password: string) {
  return api<{ id: string; email: string }>('/api/auth/login', {
    method: 'POST', body: JSON.stringify({ email, password }),
  });
}

export async function logout() {
  return api('/api/auth/logout', { method: 'POST' });
}
